import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import TtsRs from '@domain/rs/TtsRs';

const ttsPrefix = '/tts';

export default interface TtsRepo {
  // Text 해당하는 음성파일 다운로드
  getTts(text: string): Promise<AxiosResponse<TtsRs>>;
}

export class RemoteTtsRepo implements TtsRepo {
  getTts(text: string): Promise<AxiosResponse<TtsRs>> {
    return axios.get(`${ttsPrefix}`, {
      params: { text },
      responseType: 'blob',
    });
  }
}
